export default {
    getEnvironment() {
        try {
            // Splits out environment from server domain
            // e.g. local dev environment form `npm run serve`  ->  "-dev.unwsp.edu"
            // e.g. https://localhost.unwsp.edu/travel  ->  "-dev.unwsp.edu"
            // e.g. https://apps-dev.unwsp.edu/travel  ->  "-dev.unwsp.edu"
            // e.g. https://apps-test.unwsp.edu/travel  ->  "-test.unwsp.edu"
            // e.g. https://apps.unwsp.edu/travel  ->  ".unwsp.edu"
            if(process.env.NODE_ENV === 'development') {
                return "-test.oci.unw.edu";
            }
            else if(process.env.NODE_ENV === 'test') {
                return "-test.oci.unw.edu";
            }
            else if(window.location.href.split("//")[1].startsWith("localhost")) {
                return "-test.oci.unw.edu";
            }
            else {
                return window.location.href.split("apps")[1].split("/")[0];
            }
        }
        catch {
            return ".oci.unw.edu";
        }
    },
    capitalize(word) {
        var capitalized = "";
        if (word.includes(" ")) {
            var words = word.split(" ");
            words.forEach((w) => {
                w = w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() + " ";
                capitalized += w;
            })
        } else {
            capitalized = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return capitalized.trim();
    },
    dateInputFormat(date) { // used to format the input date within text fields to match the date format of the date picker
				const d = new Date(date);
				var year = d.getFullYear();
				var month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
				var day = String(d.getDate()).padStart(2, '0');
				return year + "-" + month + "-" + day;
			}
};